import { Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { firebase } from "astrid-firebase";
import createSerie from "astrid-firestore/src/api/series/createSerie";
import { Serie } from "astrid-firestore/src/api/series/types/Serie";
import updateSerie from "astrid-firestore/src/api/series/updateSerie";

import Button from "../../../ui/components/Buttons/Button";
import SidebarPortal from "../../../ui/components/SidebarPortal/SidebarPortal";
import Toast from "../../../ui/components/Toast/Toast";

import { useProfile } from "../../../authentication/state/profile";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

export default function SerieMetaDataEdit({ serie, onClose }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const user = useProfile();

	const { form, formState, onSubmit } = useSimpleForm({
		schema: Serie,
		defaultValues: {
			name: serie.name || null,
			description: serie.description || null,
			publisher: serie.publisher || null,
		},
		onSubmit: ({ name, description, publisher }) => {
			if (!serie.exists) {
				return createSerie(firebase, { publisher, name, description, createdBy: user });
			}

			return updateSerie(firebase, { ref: serie.ref, name, description, updatedBy: user });
		},
		onSuccess: (result) => {
			if (!serie.exists) {
				navigate(result.id);
			} else {
				onClose();
			}
		},
	});

	return (
		<SidebarPortal width={500} focus={formState.isDirty} open onClose={onClose}>
			<Form form={form}>
				<Segment basic padded style={{ margin: 0 }}>
					<Form.Input name="name" label={t("name", "Name")} />

					<Form.TextArea name="description" label={t("description", "Description")} />
				</Segment>

				{serie.exists && <Form.Blocker />}
			</Form>

			<Toast open>
				<Button onClick={onClose}>{t("cancel", "Cancel")}</Button>

				<Button
					primary
					onClick={onSubmit}
					disabled={formState.isSubmitting || !formState.isDirty}
					loading={formState.isSubmitting}
				>
					{t("saveChanges", "Save Changes")}
				</Button>
			</Toast>
		</SidebarPortal>
	);
}
